import { PopoverBody, PopoverBodyProps } from "@chakra-ui/react";

export interface FilterBodyProps extends PopoverBodyProps {}

export const FilterBody = (props: FilterBodyProps) => {
  return <PopoverBody px={0} py={2} {...props} />;
};
